import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

interface FlavorImageProps {
  flavorName: string;
  edition: string;
  productType?: 'Pulse' | 'Pulse X';
  height?: number | string;
  imagePath?: string;
}

const FlavorImage: React.FC<FlavorImageProps> = ({ 
  flavorName, 
  edition, 
  productType = 'Pulse',
  height = 180,
  imagePath
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Determine if we need to use jpg or png based on the edition
  const getImageExtension = (edition: string) => {
    if (edition === 'Halloween Edition') {
      return '.jpg';
    }
    return '.png';
  };
  
  // Fallback to a colored box if the image fails to load
  const generateColor = (name: string): string => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 50%)`;
  };
  
  const backgroundColor = generateColor(flavorName);
  // Use process.env.PUBLIC_URL to get the correct base URL for GitHub Pages
  const baseUrl = process.env.PUBLIC_URL || '';
  const imagePathGenerated = `${baseUrl}/images/${productType}/${edition}/${flavorName}${getImageExtension(edition)}`;
  const finalImagePath = imagePath || imagePathGenerated;
  
  const handleImageError = () => {
    console.error(`Failed to load image: ${finalImagePath}`);
    setImageError(true);
  };
  
  return (
    <Box
      sx={{
        height,
        width: '100%',
        backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {!imageError ? (
        <img 
          src={finalImagePath}
          alt={flavorName}
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'contain',
            backgroundColor: 'white',
          }}
          onError={handleImageError}
        />
      ) : (
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            color: 'white',
            textAlign: 'center',
            padding: 2,
          }}
        >
          {flavorName}
        </Typography>
      )}
    </Box>
  );
};

export default FlavorImage;
